<template>
  <div>
    <b-col md="13" class="mb-1">
      <info-user ref="infoUser" :user="user" @update-info="updateUserInfo" />
    </b-col>
    <b-col md="13" class="mb-1">
      <fonction-user ref="fonctionUser" :user="user" @update-fonction="updateUserFonction" />
    </b-col>
    <b-col md="13" class="mb-1">
      <user-hierarchique ref="userHierarchique" :users="user.usersHierarchique"
        @update-hierarchy="updateUserHierarchy" />
    </b-col>

    <b-button @click="validateAndSaveUser" variant="primary">Enregistrer</b-button>
  </div>
</template>

<script>
import { BCol, BButton } from 'bootstrap-vue';
import { saveUser, getIdUsers, updateUsers } from '@/services/UserService';
import InfoUser from './InfoUser.vue';
import FonctionUser from './FonctionUser.vue';
import UserHierarchique from './UserHierarchique.vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { required } from '@validations'

export default {
  components: {
    InfoUser,
    FonctionUser,
    UserHierarchique,
    BCol,
    BButton,
    //eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      user: {
        lastName: '',
        firstName: '',
        mail: '',
        telephone: '',
        fonction: '',
        role: null,
        matricule:'',
        fonctionDate: null,
        directions: { id: null },
        services: { id: null },
        toll: { id: null },
      
        usersHierarchique: [],
      },
    };
  },
  methods: {
    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        { position }
      );
    },
    updateUserInfo(user) {

      Object.assign(this.user, user);

    },
    updateUserFonction(user) {
      Object.assign(this.user, {
        fonction: user.fonction,
        directions: user.directions,
        services: user.services,
        toll: user.toll,
      });
    },
    updateUserHierarchy(users) {
      this.user.usersHierarchique = users;
    },
    async validateAndSaveUser() {
      const infoUserValid = await this.$refs.infoUser.validateForm();
      const fonctionUserValid = await this.$refs.fonctionUser.validateForm();

      if (infoUserValid && fonctionUserValid) {
        await this.saveUser();
        this.resetForm();

        // Redirection vers la page liste des utilisateurs
        this.$router.push({ name: 'Liste' });
      } else {
        this.showToast('primary', 'top-right', 'Veuillez corriger les erreurs dans le formulaire.');
      }
    },
    async fetchUserData() {
      const userId = this.$route.params.id;
      if (userId) {
        try {
          const response = await getIdUsers(userId);

          if (response) {

            this.user = {
              ...this.user,
              ...response,
              directions: response.directions || { id: null },
              services: response.services || { id: null },
              toll: response.toll || { id: null },
              usersHierarchique: response.usersHierarchique || [],
            };
            this.$refs.infoUser.updateForm(this.user);
            this.$refs.fonctionUser.updateForm(this.user);
            this.$refs.userHierarchique.updateForm(this.user);

          } else {
            this.showToast('warning', 'top-right', "L'utilisateur n'a pas été trouvé.");
          }
        } catch (error) {
          console.error('Erreur lors de la récupération des données utilisateur:', error);
          this.showToast('error', 'top-right', 'Impossible de charger les données utilisateur.');
        }
      }
    },
    async saveUser() {
    
      try {
        if (this.user.id) {
          await updateUsers(this.user.id, this.user);
          this.showToast('success', 'top-right', 'Utilisateur modifié avec succès !');
          // this.$router.push({ name: 'ajouter-user'})

        } else {
          await saveUser(this.user);
          this.showToast('success', 'top-right', 'Utilisateur enregistré avec succès !');

        }


      } catch (error) {
        console.error('Erreur lors de l\'enregistrement de l\'utilisateur:', error);
        this.showToast('error', 'top-right', 'Erreur lors de l\'enregistrement de l\'utilisateur.');
      }
    },
    resetForm() {
      this.user = {
        lastName: '',
        firstName: '',
        mail: '',
        telephone: '',
        fonction: '',
        role: null,
        matricule:'',
        fonctionDate: null,
        directions: { id: null },
        services: { id: null },
        toll: { id: null },
        usersHierarchique: [],
      };
      this.$refs.infoUser.reset();
      this.$refs.fonctionUser.reset();
      this.$refs.userHierarchique.reset();
    },
  },
  created() {
    this.fetchUserData();
  },
};
</script>

<style lang="scss" scoped>
.mb-1 {
  margin-bottom: 1rem;
}

@import '@core/scss/vue/libs/vue-select.scss';
</style>
